export function getProjectNumberFromUrl(): string | undefined {
  const jobNumber = new URLSearchParams(window.location.search).get('jobNumber');
  return jobNumber && jobNumber !== 'null' ? jobNumber : undefined;
}
